import React, { useCallback } from 'react'
import { DialogTitleWithCloseButton, DraggablePaperGenerator, Loader } from '@carsys/ui'
import { useQueryParam } from '@cbgms/base/hooks/use-query-param/use-query-param'
import LicensePlate from '@cbgms/components/form/LicensePlate'
import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useGetVehicle } from 'app/vehicles/hooks/useGetVehicle'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import VehicleDetailsGrid from '../VehicleValidContainer/Modes/Components/VehicleDetailsGrid'
import { duplicateVehicleModalQueryParam, duplicateVehicleUUIDQueryParam, duplicateVehicleVinQueryParam } from './const'

const draggableID = 'vehicle_duplicate_registration_modal'
const useStyles = makeStyles({
  vehicleGrid: {
    width: '100% !important'
  }
})

export const DuplicateVehicleFoundModal: React.FC<{}> = () => {
  const history = useHistory()
  const { t } = useTranslation()
  const [, IsModalOpen] = useQueryParam(duplicateVehicleModalQueryParam)
  const [duplicateVehicleUUID] = useQueryParam(duplicateVehicleUUIDQueryParam, '')
  const [, IsVin] = useQueryParam(duplicateVehicleVinQueryParam)
  const DragPaper = DraggablePaperGenerator(draggableID)
  const classes = useStyles()
  const vehicleQuery = useGetVehicle(duplicateVehicleUUID)

  const onClose = useCallback(() => {
    history.replace(history.location.pathname)
  }, [history.replace, history.location.pathname])

  const onGoToVehicle = useCallback(() => {
    history.push(`/vehicles/${duplicateVehicleUUID}`, { skipNavigationPrompt: true })
  }, [history.push, duplicateVehicleUUID])

  return (
    <Dialog open={!!IsModalOpen} onClose={onClose} maxWidth='xl' scroll='paper' PaperComponent={DragPaper} sx={{ zIndex: 1500 }}>
      <DialogTitleWithCloseButton onClose={onClose} draggableIDHandler={draggableID}>
        <Box display='inline-block' marginRight={5}>
          {IsVin ? t('duplicate_vehicle.title_duplicate_vehicle_vin') : t('duplicate_vehicle.title_duplicate_vehicle_registration')}
        </Box>
      </DialogTitleWithCloseButton>
      <DialogContent dividers>
        <Box mb={1}>
          <Typography variant='h6'>
            {IsVin ? (
              <>
                {t('duplicate_vehicle.explain_duplicate_vehicle_vin')} {vehicleQuery.data?.Vin}
              </>
            ) : (
              <>
                {t('duplicate_vehicle.explain_duplicate_vehicle_registration')}
                <LicensePlate registration={vehicleQuery.data?.Registration} size='small' />
              </>
            )}
          </Typography>
        </Box>
        <Box>
          {vehicleQuery.isLoading && <Loader linear loading />}
          {vehicleQuery.data && <VehicleDetailsGrid vehicle={vehicleQuery.data} className={classes.vehicleGrid} />}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} data-testid='btn-close-modal'>
          {t('global.close')}
        </Button>
        {duplicateVehicleUUID && (
          <Button color='primary' onClick={onGoToVehicle} data-testid='btn-close-modal'>
            {t('duplicate_vehicle.go_to_vehicle')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
